"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ghsPictogramText = void 0;
exports.ghsPictogramText = {
    GHS01: 'Explosive',
    GHS02: 'Flammable',
    GHS03: 'Oxidizing',
    GHS04: 'Compressed Gas',
    GHS05: 'Corrosive',
    GHS06: 'Toxic',
    GHS07: 'Harmful Irritant',
    GHS08: 'Health Hazard',
    GHS09: 'Environmental Hazard',
};
//# sourceMappingURL=ghsPictograms.js.map